import { inject } from 'vue';
import type { DependencyIdentifier, Injector } from '@wendellhu/redi';
import { INJECTOR_KEY } from '@/constants/di';

export function useDependency<T>(id: DependencyIdentifier<T>): T {
  const injector = inject<Injector>(INJECTOR_KEY);
  if (!injector) throw new Error('[useDependency] DI injector 未提供。请检查 main.ts 是否调用 app.provide(INJECTOR_KEY, injector)');
  return injector.get(id);
}
